/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetBpTpHistoryParams,
  GetBpTpListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary BP TP History
 */
export const getBpTpHistory = (params?: GetBpTpHistoryParams, signal?: AbortSignal) => {
  return customInstance<GetBpTpListResponseResponse>({
    url: `/bm-declaration-service/v1/bp-tp`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetBpTpHistoryQueryKey = (params?: GetBpTpHistoryParams) => {
  return [`/bm-declaration-service/v1/bp-tp`, ...(params ? [params] : [])] as const;
};

export const getGetBpTpHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getBpTpHistory>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetBpTpHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpHistory>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBpTpHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBpTpHistory>>> = ({ signal }) =>
    getBpTpHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBpTpHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBpTpHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getBpTpHistory>>>;
export type GetBpTpHistoryQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary BP TP History
 */
export const useGetBpTpHistory = <
  TData = Awaited<ReturnType<typeof getBpTpHistory>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetBpTpHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpHistory>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBpTpHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
